import { AddTag } from '../AddTag';

interface props {
  confirm?: (tags: string[]) => void;
  onUpdate?: (tags: string[]) => void;
  cancel?: () => void;
  getTags: () => Promise<string[]>;
  section: string;
}

export default function Tags(props: props) {
  return <AddTag section={props.section} selected={[]} save={props.confirm} cancel={props.cancel} />;
}
